import { axios } from '@/utils/request'

// App management
export function getRepaymentReportList (parameter = {}) {
  return axios({
    url: '/repaymentReport/list',
    method: 'post',
    data: parameter
  })
}
